<template>
    <tr :class="getTrClass(rowLevel, statisticIndex)">
        <td
            v-if="statisticIndex === headingRow"
            class="row-heading"
            v-html="getRowHeading(rowLevel.rowLevel.title.toString())"
        ></td>
        <td v-if="statisticIndex !== headingRow" class="row-heading">
            <div class="accessibleHide">No value</div>
        </td>
        <td class="statistic-label" :title="statisticDefinition.label">
            {{ getStatisticLabel(statisticDefinition) }}
        </td>
        <template v-for="model in models">
            <statistic-value
                ref="statisticValues"
                :statistic="model"
                v-bind:key="100 + model.id"
            ></statistic-value>
            <statistic-ci
                ref="statisticCis"
                v-if="reportModel.parms.showCi"
                :statistic="model"
                v-bind:key="200 + model.id"
            ></statistic-ci>
            <statistic-se
                ref="statisticSes"
                v-if="reportModel.parms.showSe"
                :statistic="model"
                v-bind:key="300 + model.id"
            ></statistic-se>
        </template>
        <template v-if="!hasTotal">
            <td class="last-column"></td>
            <td
                class="last-column"
                v-if="selectionModel.selectedStatistics.confidenceInterval"
            ></td>
            <td
                class="last-column"
                v-if="selectionModel.selectedStatistics.standardError"
            ></td>
        </template>
    </tr>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import current from '@/scripts/current';
import statisticValue from '@/components/crossTabulation/report/statisticValue';
import statisticCi from '@/components/crossTabulation/report/statisticCi';
import statisticSe from '@/components/crossTabulation/report/statisticSe';

export default {
    props: [
        'models',
        'reportModel',
        'rowLevel',
        'statisticDefinition',
        'statisticIndex',
        'isControlTotalCombinedYears',
        'row',
        'columns'
    ],
    computed: {
        selectionModel: function () {
            return current.selectionModel;
        }
    },
    data: function () {
        var vm = this;
        let isColumnTotal = vm.rowLevel.rowLevel.id === 0;
        let hasTotal =
            vm.rowLevel.rowLevel.id !== 0 ||
            vm.statisticDefinition.apiName === 'sampleSize' ||
            vm.statisticDefinition.apiName === 'weightedN';
        return {
            headingRow:
                Math.floor((vm.reportModel.usedStatistics.length + 1) / 2) - 1,
            isRowTotalCombinedYears: current.modelHelper.isYearTotal(
                'row',
                vm.rowLevel.rowLevel
            ),
            isColumnTotalCombinedYears: current.modelHelper.isYearTotal(
                'column',
                null
            ),
            isColumnTotal: isColumnTotal,
            rowSourceRecords: vm.row.totalSourceRecords,
            hasTotal: hasTotal
        };
    },
    components: {
        // <my-component> will only be available in parent's template
        'statistic-value': statisticValue,
        'statistic-ci': statisticCi,
        'statistic-se': statisticSe
    },
    methods: {
        addXlsxRows,
        makeSpacesNonBreaking: function (label) {
            return label.replace(/\s/g, '&nbsp;');
        },
        getRowHeading: function (label) {
            var breakingPoint = 18;
            return label.length <= breakingPoint
                ? this.makeSpacesNonBreaking(label)
                : this.makeSpacesNonBreaking(label.substr(0, breakingPoint)) +
                      label.substr(breakingPoint);
            //return label.replace(' ', '&nbsp;');
        },
        getTrClass: function (rowLevel, statisticIndex) {
            var vm = this;
            var classes = [];
            if (statisticIndex === 0) classes.push('first-row');
            else if (
                statisticIndex ===
                vm.reportModel.usedStatistics.length - 1
            )
                classes.push('last-row');
            if (rowLevel.rowLevel.id === 1) classes.push('first-group');
            else if (rowLevel.rowLevel.id === 0) classes.push('total-group');
            return classes.join(' ');
        },
        getStatisticLabel: function (statisticDefinition) {
            switch (statisticDefinition.apiName) {
                case 'sampleSize':
                    return 'n';
                case 'rowPercentage':
                    return 'Row%';
                case 'columnPercentage':
                    return 'Col%';
                case 'totalPercentage':
                    return '%';
                case 'weightedN':
                    return 'Weighted N';
                default:
                    return statisticDefinition.apiName;
            }
        }
    }
};

function addXlsxRows(sheet) {
    let vm = this;
    if (vm.statisticIndex === 0)
        sheet.mergeCellAcrossRows(0, vm.reportModel.totalNumberOfStatistics);
    let rowTitle =
        vm.statisticIndex === 0 ? vm.rowLevel.rowLevel.title.toString() : '';
    let label = vm.statisticDefinition.label;

    //let statisticValues = vm.$refs.statisticValues.map(sv => sv.theValue).filter(v => v !== null);
    let modelsToShow = vm.models.filter((sv) => sv.show);
    let statisticValues = modelsToShow.map((sv) => sv.footnote + sv.xlsxValue);
    //sheet.addRow([rowTitle, label, ...vm.models.map(m => m.floatValue)]);
    sheet.addRow([rowTitle, label, ...statisticValues]);

    // <statistic-value ref="statisticValues" :statistic="model" v-bind:key="100 + model.id"></statistic-value>
    // <statistic-ci ref="statisticCis" v-if="reportModel.parms.showCi" :statistic="model" v-bind:key="200 + model.id"></statistic-ci>
    // <statistic-se ref="statisticSes" v-if

    if (
        vm.statisticDefinition.apiName !== 'sampleSize' &&
        vm.reportModel.parms.showCi
    )
        sheet.addRow([
            '',
            'C.I. for ' + label,
            ...modelsToShow.map((m) => m.formattedCi)
        ]);
    if (
        vm.statisticDefinition.apiName !== 'sampleSize' &&
        vm.reportModel.parms.showSe
    )
        sheet.addRow([
            '',
            'S.E. of ' + label,
            ...modelsToShow.map((m) => m.standardError)
        ]);
}
</script>

<style scoped>
/*table {
    position: relative;
    table-layout: fixed;
    width: 100%;
  } */

table td {
    overflow: hidden;
}

table tbody tr:last-child td {
    border: none;
}

table td.statistic-total {
    text-align: center;
}
/*table td.nth-child(2) {
      white-space: nowrap;
    }*/
td {
    white-space: nowrap;
}

/* table td.statistic-cell {
    white-space: nowrap;
  } */

.statistic-label {
    padding: 0px 10px 0px 10px;
    /*white-space: nowrap;*/
}

/*table tr.first-row td:nth-child(2) {
    border-left: 2px solid;
  }*/

table tr:not(.total-group) td.statistic-value {
    border-left: 2px solid;
}

td.statistic-value {
    padding-left: 10px;
}

table tr.first-row td.statistic-cell {
    border-top: 2px solid;
}

table {
    padding-top: 15px;
    /*margin-left: 50px;*/
}

table tr.first-row td {
    padding-top: 4px;
}

table tr.first-row td {
    padding-top: 15px;
}

table tr.last-row td {
    padding-bottom: 15px;
}

div.column-title {
    background-color: #8eab6b;
    width: fit-content;
    padding: 5px 10px 5px 10px;
    min-width: 200px;
}

.column-headings {
    background-color: #8eab6b;
    width: fit-content;
    padding: 5px 10px 5px 10px;
}

div.row-title {
    width: fit-content;
    background-color: #c1d5b0;
    padding: 5px 10px 5px 10px;
    min-width: 200px;
}

.row-heading {
    width: fit-content;
    background-color: #c1d5b0;
    white-space: inherit;
    padding: 5px 10px 5px 10px;
    font-weight: bold;
}
</style>
